module.exports = __webpack_public_path__ + "static/img/no_live.5f349727.png";